// extracted by mini-css-extract-plugin
export default {"container":"cyeW9uH_d","darker":"cTiDzTHM1","whiteMode":"cACQMHApJ","alignItemsStart":"chcu8O2ry","bigger":"cJ7ud5lQh","closeButton":"cAczuAnY_"};